<template>
    <div style="background-color: whitesmoke; overflow-x: auto;" > 
        <!-- <CCardBody class="" style="min-width: 1000px; max-height: 600px;"> -->
        <CCardBody class="financial-chart-body">    
            <h5>{{ $t('Financial chart') }}</h5>
            
            <CChartLine

                type      = "line"
                :wrapper  = "false"
                :labels   = "labels"
                :datasets = "datasets"                
                :options = "options"
            />
           
        </CCardBody>
    </div>
</template>

<script>

import { CChartLine  } from '@coreui/vue-chartjs'

export default {
    name: 'FinancialChart',
    components: {
        CChartLine
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        start_bankroll : {
            type: Number,
            default: () => 0
        }
    },
    data () {
        return {
            datasets: [
                {
                    fill: false,
                    tension: 0.1,
                    label: 'Back',                    
                    borderColor: '#00D8FF',
                    data: []
                },
                {
                    fill: false,
                    tension: 0.1,
                    label: 'Lay(payout)',                    
                    borderColor: '#EAC7C7',
                    data: []
                },
                {
                    fill: false,
                    tension: 0.1,
                    label: 'Lay(liability)',                    
                    borderColor: '#FBE7E7',
                    data: []
                },
                {
                    fill: false,
                    tension: 0,
                    label: 'Start Bank',
                    borderColor: 'lightgreen',
                    data: [],
                    pointRadius: 0,
                    borderWidth: 4,
                    
                },
            ],
            options: {
                maintainAspectRatio: false,
                // aspectRatio: 1, 
                scales: {
                  yAxes: [{
                    ticks: {
                      callback: (val) => (`${val}`)
                    }
                  }]
                }
            }
        }
    },
    created() {
        this.init();
        
    },
    computed: {
        labels() {
            console.log('items======>>>>>>>>>', this.items)
            let labels = [];
            let totalData = [];
            let data1=[], data2=[], data3=[], data4=[];
            for ( let i=0; i<this.items.length; i++ ) {
                let cur_item = this.items[i];

                labels.push( `${cur_item.day}/${cur_item.month}/${cur_item.year}` );
                data1.push(cur_item.back);
                data2.push(cur_item.lay_payout);
                data3.push(cur_item.lay_liability);
                data4.push(this.start_bankroll)
            }
            this.datasets[0].data = data1;
            this.datasets[1].data = data2;
            this.datasets[2].data = data3;
            this.datasets[3].data = data4;
            return labels;
        }
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        init() {
            console.log('items======>>>>>>>>', this.items)
        },
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
    }
}
</script>
<style scoped>
    .positive-mark {
        color: green
    }
    .negative-mark {
        color: red
    }
    .leverage_color_weight {
        background-color: #FFC000;
    }
    .leverage_color_light {
        background-color: #FFF2CC !important;
    }
    .comp_color_weight {
        background-color: #9BC2E6;
    }
    .comp_color_light {
        background-color: #DDEBF7 !important;
    }
    .cell_left_solid {
        /*border-left: solid !important;
        border-left-color: black !important;*/
        border-left: groove;
    }
    .cell_right_solid {
        /*border-right: solid !important;
        border-right-color: black !important;*/
        border-right: groove;
    }
    

</style>
<style>


.tips_financial_table_modify .table-responsive{
    margin-top: 20px !important;
    max-height: 80vh !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
.leverage_color_light {
    background-color: #FFF2CC !important;
}
.comp_color_weight {
    background-color: #9BC2E6;
}
.comp_color_light {
    background-color: #DDEBF7 !important;
}
.cell_left_solid {
    /*border-left: solid !important;
    border-left-color: black !important;*/
    border-left: groove;
}
.cell_right_solid {
    /*border-right: solid !important;
    border-right-color: black !important;*/
    border-right: groove;
}
.outcome-col {
    color:  white;
    min-width: 35px;
    display: inline-block;
    border-radius: 5px;
}
.green-background {
    background-color:  green;
}
.red-background {
    background-color:  red;
}
/*canvas.chartjs-render-monitor {
    max-height: 600px !important;
    max-width: 1200px !important;

}*/
canvas.chartjs-render-monitor {
    height: 500px !important;
}
@media (max-width: 1800px) {
    /*.financial-chart-body {
        min-width: 1000px;
    }*/
    canvas.chartjs-render-monitor {
        height: 450px !important;
    }
    
}
@media (max-width: 1200px) {
    /*.financial-chart-body {
        min-width: 1000px;
    }*/
    canvas.chartjs-render-monitor {
        height: 400px !important;
    }
    
}
@media (max-width: 576px) {
    /*.financial-chart-body {
        min-width: 1000px;
    }*/
    canvas.chartjs-render-monitor {
        height: 350px !important;
    }
    
}
</style>